import { FormState, ProductData } from "../../types/product";

// ─── All Products ─────────────────────────────────────────────────────────────

export function formatDate(iso: string): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

// ─── Manage Product ───────────────────────────────────────────────────────────

export function uid(): string {
  return Math.random().toString(36).slice(2, 8);
}

export function hydrateProduct(product: ProductData): FormState {
  return {
    product_description:    product.product_description || "",
    meta_title:             product.meta_title || "",
    meta_description:       product.meta_description || "",
    status:                 product.status    || "draft",
    product_specifications: (product.product_specifications || []).map((s) => ({
      ...s,
      id: uid(),
    })),
    product_key:            product.product_key || "",
    tab_name:               product.tab_name || "",
    tab_sub:                product.tab_sub || "",
    ec:                     product.ec || "",
    name:                   product.name || ["", ""],
    name_em_start:          product.name_em_start || 0,
    tagline:                product.tagline || "",
    formats:                product.formats || [],
    certs:                  product.certs || [],
    cta_copy:               product.cta_copy || "",
    applications:           (product.applications || []).map((app) => ({
      ...app,
      id: uid(),
      heading: app.heading || ["", ""],
      metrics: (app.metrics || []).map((m) => ({ ...m })),
      buyers: app.buyers || [],
      flowSteps: (app.flowSteps || []).map((fs) => ({ ...fs })),
    })),
    focusKeyword:           product.focusKeyword || "",
    secondaryKeywords:      product.secondaryKeywords || [],
    faqs:                   product.faqs || [],
    metaTitle:              product.metaTitle || product.meta_title || "",
    metaDescription:        product.metaDescription || product.meta_description || "",
    tds_url:                product.tds_url || "",
  };
}
